function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:currentColor}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "\\u30EC\\u30A4\\u30E4\\u30FC_2",
  "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u30EC\\u30A4\\u30E4\\u30FC_2-2",
  "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 2"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M20.339 13.267h-8.678a1.49 1.49 0 00-1.49 1.489V29.91a1.49 1.49 0 001.49 1.49h8.678a1.49 1.49 0 001.49-1.49V14.756a1.49 1.49 0 00-1.49-1.489zm-.129 14.9h-8.42V16.505h8.42zM18.405 5.6v-5h-5v5h-3.5L16 11.9l6.095-6.3h-3.69z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h32v32H0z"
})));

var SvgMobileAppmin = function SvgMobileAppmin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMobileAppmin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/MobileApp.min.cbae7b59.svg";
export { ForwardRef as ReactComponent };